import { chain } from 'lodash';
import { findRequiredFields, validDomesticBankFields } from './disable-submit';
import {
  influencerHandlesHasEmptyPlatform,
  influencerHandlesHasEmptyHandle,
  isValidAccountNumber,
  isValidRoutingNumber,
} from '../FormUtils/vendor-application';

/**
 * Creates an array of the missing fields from the submitted form
 * @param {object} form all of the fields and values from submitted form
 * @param {boolean} hasWirePayment whether the wire payment section of form is enabled
 * @param {boolean} update whether the submit is to update an existing vendor
 *
 * @returns {array} an array of any required fieldst that are missing from the form
 */
export default function findMissingFields(form, update = false) {
  const requiredFields = findRequiredFields(form);

  let fields = chain(requiredFields)
    .omitBy(
      (value) =>
        !(
          value === undefined ||
          value === null ||
          value === 0 ||
          value === false ||
          Number.isNaN(value) ||
          value === '' ||
          (typeof value === 'string' && value.trim() === '')
        ),
    )
    .keys()
    .value();

  if (update) {
    if (fields.includes('reEnterAccountNumber'))
      fields = fields.filter((field) => field !== 'reEnterAccountNumber');
    if (fields.includes('reEnterRoutingNumber'))
      fields = fields.filter((field) => field !== 'reEnterRoutingNumber');
  }

  if (!update && !validDomesticBankFields(form)) {
    if (!isValidRoutingNumber(form.routing_number))
      fields.push('routing_number');
    if (isValidAccountNumber(form.account_number))
      fields.push('account_number');
  }

  // If influencer_handles is included, it means it's empty so both platform and handle are empty on the UI.
  if (
    fields.includes('influencer_handles') ||
    !form.influencer_handles ||
    !form.influencer_handles.length
  ) {
    fields = fields.filter((field) => field !== 'influencer_handles');
    fields.push('influencer_platform');
    fields.push('influencer_handle');
  } else {
    if (influencerHandlesHasEmptyPlatform(form.influencer_handles))
      fields.push('influencer_platform');
    if (influencerHandlesHasEmptyHandle(form.influencer_handles))
      fields.push('influencer_handle');
  }

  return fields;
}
